import { Component, OnInit } from '@angular/core';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-tickets-new-ticket-dashboard',
  templateUrl: './tickets-new-ticket-dashboard.component.html',
  styleUrls: ['./tickets-new-ticket-dashboard.component.scss']
})
export class TicketsNewTicketDashboardComponent implements OnInit {

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-receipt', 'tickets-page.new ticket', '/account/tickets', [new BRoute('account-page.account', '/account'), new BRoute('tickets-page.tickets', '/account/tickets'), new BRoute('tickets-page.new ticket')]));
  }
}
